import React from 'react';

import HeaderDesktop from './components/HeaderDesktop';
import HeaderMobile from './components/HeaderMobile';

const Header = () => (
  <>
    <HeaderMobile />
    <HeaderDesktop />
  </>
);

export default Header;
